import { themeStyle } from '@repo/ui/theming';
import styled, { css, keyframes } from 'styled-components';

const loadIndicatorY = keyframes`
  0% {
    transform: scaleY(0);
  }
  99% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0);
  }
`;

export const animationRuleY = css`
  ${loadIndicatorY};
`;

const sizes = css`
  width: 4px;
  height: 100%;
  border-radius: 100px;
`;

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const Background = styled.div`
  position: absolute;
  background-color: ${themeStyle.varBlueLight};
  overflow: hidden;

  ${sizes};
`;

export const Indicator = styled.div<{
  duration: number;
}>`
  background-color: ${themeStyle.varBlueMedium};

  ${sizes};

  transform: scaleY(0);
  transform-origin: top;

  animation: ${animationRuleY};
  animation-duration: ${({ duration }) => duration}ms;
  animation-timing-function: linear;
  animation-play-state: running;
  animation-iteration-count: infinite;
`;
